import {
  StyledStack,
  StyledSection,
  StyledHeadline,
  SingleBenefitWrapper,
  StyledBenefitHeadline,
  StyledBenefitsWrapper,
  StyledBenefitDescription,
  StyledIconWrapper,
  StyledIcon,
  StyledIconBackground,
} from './styles';
import { WhyRFData } from './WhyRF.data';

export const WhyRF = ({ ...props }) => {
  const why = WhyRFData();

  return (
    <StyledSection width="normal">
      <StyledStack {...props}>
        <StyledHeadline
          display={{ xs: 'none', md: 'block' }}
          variant="display_md"
          paragraph>
          Why Rumble Fish for Stellar Development?
        </StyledHeadline>
        <StyledHeadline
          display={{ xs: 'block', md: 'none' }}
          variant="display_md"
          paragraph>
          Why Rumble Fish for Stellar Development?
        </StyledHeadline>

        <StyledBenefitsWrapper>
          {why.map((el, index) => {
            return (
              <SingleBenefitWrapper key={index}>
                <StyledIconWrapper>
                  <StyledIconBackground>
                    <StyledIcon src={el.icon} alt={el.title} />
                  </StyledIconBackground>
                </StyledIconWrapper>
                <StyledBenefitHeadline variant="strong_500">
                  {el.title}
                </StyledBenefitHeadline>
                <StyledBenefitDescription variant="regular_400">
                  {el.description}
                </StyledBenefitDescription>
              </SingleBenefitWrapper>
            );
          })}
        </StyledBenefitsWrapper>
      </StyledStack>
    </StyledSection>
  );
};
